import { Navigate, useLocation } from 'react-router-dom';
import { isAdmin, isAuthenticated } from '../services/authService';

export function ProtectedRoute({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin()) {
    return <Navigate to="/login" state={{ error: 'Admin access required' }} replace />;
  }

  return children;
}
